import serverData from './server-data'

export const isFeatureEnabled = (featureName) => {
  const { country = '', featureFlags = {} } = serverData
  const featureNameValue = featureFlags[featureName]
  if (featureNameValue) {
    return featureNameValue.indexOf(country) !== -1
  }
  return false
}

export const isFeatureNotEnabled = (featureName) => {
  const { country = '', featureFlags = {} } = serverData
  const featureNameValue = featureFlags[featureName]
  if (featureNameValue) {
    return featureNameValue.indexOf(country) === -1
  }
  return false
}

// This function is used to parse the string object
//Ex: dsrRecaptchaSiteKey: "{\"sitekey\":\"6Lfg59kcAAAAAGmFghbonojJugMKZZ7aq9dcu97U\"}"
export const getFeatureValue = (featureName) => {
  const { featureFlags = {} } = serverData
  const featureNameValue = featureFlags[featureName]
  return featureNameValue || false
}

export const isStateFeatureEnabled = (featureValue) => {
  const { country, userState } = serverData
  const excludedStates = getFeatureValue(featureValue)
  const states = excludedStates[country]
  if (states && states.length > 0) {
    return states.indexOf(userState) === -1
  }
  return false
}
